module.exports = __webpack_public_path__ + "static/blue-ocean-strategy-d47d576294e9331f08d80eeb2c037e2a.jpg";